export const DIALOG_TYPE_ADD = 0;
export const DIALOG_TYPE_EDIT = 1;
